<!-- @format -->

<info-basic-information-tag>

    <div class="container_contents">

        <div class="container_breadcrumb">
            <ul class="breadcrumb">
                <li class="breadcrumb-item"><a href="/info" class="information">会員情報</a></li>
                <li class="breadcrumb-item"><h1>登録基本情報の更新申請</h1></li>
            </ul>
        </div>

        <div class="contents">
            <section class="contents_area">

                <div class="contents_block">
                    <h1 style="font-size: 2.5rem;text-align: center;margin-bottom:1rem">
                        登録基本情報の更新申請
                    </h1>

                    <p class="important_message important_message02 margin-spacing-4_bottom">
                        登録基本情報を入力いただき、本人確認書類として身分証明書の提出と、マイナンバーの登録をお願いいたします。
                        <br>尚、住所等に変更があった際は、本画面より再提出を行っていただく必要があります。
                        <br>※入力完了後、申請内容を事務局にて確認いたします。問題がなければ登録完了となります。</p>
                    <h2 class="heading-03 margin-spacing-4_top margin-spacing-2_bottom">登録基本情報<span
                            class="status_label status_label-required margin-spacing-2_left"></span></h2>
                    <div is="basicform"></div>
                </div>

            </section>
        </div>

    </div>
    <script>
        import basicform from "@tags/parts/info/basic-information/form.riot";
        import basicInformation from "@model/basicInformation/api";

        export default {
            api: null,
            components: {
                'basicform': basicform,
            },
            state: {
                application: null
            },
            basicInformation: basicInformation,
            listenerUpdate() {
                this.update()
            },
            onMounted(props, state) {
                this.basicInformation.on('update', this.listenerUpdate)
            },
            onUnmounted(props, state) {
                this.basicInformation.off('update', this.listenerUpdate)
            }
        }
    </script>
</info-basic-information-tag>